import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

const GLOBAL = require('../../Globals');

class Loan extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			idd : '',
			dept : '',
			payhead : '',
			depart : [],
			accyear : [],
			payhe : [],
			emp : [],
			desig : '',
			employee : '',
			tdate : '',
			month : '',
			amt : '',
			dues : '',
			upamt : '',
			updues : '',
			uppayhead : '',
			update : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			 posts: [],
			 salary : []
		}
		this.onChange = this.onChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(){
		
		this.setState({idd : ''});
		
	}
	
	/** set value to datepicker **/
	handleDateChange(date){
		
		this.setState({
		  tdate: date
		});
	}
	
	onClick(e){
		
		document.getElementById("salform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
		this.getemployee();
		this.getdata();
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('payroll/addloans',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Added Successfullly',
					alertClass:'alert alert-success'
				});
				this.state = {month : '',
					amt : '',
					dues : ''};
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
			}
		});
		// alert('id '+id+'pay '+payhead+' val '+e.target.value);
		console.log(this.state.salary);
	}
	
	onUpdateSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('payroll/updateloansind',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Updated Successfullly',
					alertClass:'alert alert-success'
				});
				this.state = {month : '',
					amt : '',
					dues : ''};
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
			}
		});
		// alert('id '+id+'pay '+payhead+' val '+e.target.value);
		console.log(this.state.salary);
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('payroll/deleteloans',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}
	
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.getloandata();
	}
	
	getdate(dob){
		
		 var emptydob = '';
		if(dob!=''){
			var ed = new Date(dob);
			var edate = ed.setDate(ed.getDate());
			
			var d = new Date(edate),
			month = '' + (d.getMonth() + 1),
			day = '' + (d.getDate()),
			year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return [day, month, year].join('-');
		}
		else{
			
			return emptydob;
		}
	}
	
	getloandata(){
		
		var emp = $("#employ").val();
		$("#showLoader").show();
		GetData('payroll/getloansbyempandid/'+emp+'/'+this.state.idd).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					
					upamt : res[0]['amount'],
					updues : res[0]['noofdues'],
					uppayhead : res[0]['payhead'],
					update : res[0]['ldate']
				});
			}
		});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		this.getdepartment();
		this.getpayhead();
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					depart : responseJson
				});
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		
		var cs = $("#depart").val();
		GetData('employee/getempbydept/'+cs).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					emp : responseJson
				});
			}
		});
	}
	
	getdata(){
		var emp = $("#employ").val();
		GetData('payroll/getloansbyemp/'+emp).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Payhead **/
	getpayhead(){
		$("#showLoader").show();
		GetData('payroll/getpayheadforloan').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					payhe : responseJson
				});
			}
		});
	}
	
	
  render() {
	
	var dept = this.state.depart;
	var acyear = this.state.accyear;
	var pay = this.state.payhe;
	
	if(this.state.acyear!='' && this.state.dept!='' && this.state.employee!=''){
		
		$("#salset").show();
	}
	else{
		
		$("#salset").hide();
	}
	
	if(this.state.idd!=''){
		
		$("#editloan").show();
		$("#addloan").hide();
	}
	else{
		
		$("#editloan").hide();
		$("#addloan").show();
	}
	
	  /** get Employee By Department **/
	$("#depart").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'employee/getempbydept/'+fr,function(o){
			$("#showLoader").hide();
			$("#employ").html('');
			$('#employ')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Employee- ')); 
			$.each(o,function(key,value){			
				   $('#employ')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.empname)); 	
										
			});	
			
		},'json');
	
	});
	   
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
					<CardHeader>
						<strong>Advance & Loans</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						Academic Year : &nbsp;&nbsp;
						<select name="acyear" onChange={this.onChange} required id="year">
							<option value="">Select Academic Year</option>
							{
								acyear.map(function (item) {
									return <option value={item.id }>{item.value}</option>;
								})
							}
						</select>&nbsp;&nbsp;
						Department : &nbsp;&nbsp;
						<select name="dept" onChange={this.onChange} required id="depart">
							<option value="">Select Department</option>
							{
								dept.map(function (item) {
									return <option value={item.id }>{item.department}</option>;
								})
							}
						</select>&nbsp;&nbsp;
						Employee : &nbsp;&nbsp;
						<select name="employee" onChange={this.onChange} required id="employ">
							
						</select>
					</CardHeader>
					<CardBody id="salset">
					 <Row>
					  <Col md="7">
						<Table responsive bordered  id="atttable">
						  <thead>
							<tr>
								<th>S.No</th>
								<th>Payhead</th>
								<th>Amount</th>
								<th>Manage</th>
							</tr>
						  </thead>
						  <tbody>
							{this.state.posts.map((item,i) =>
						 
								<tr key = {item}>
									<td>{i+1}</td>
									<td>Salary Advance</td>
									<td>{item.amount}</td>
									<td>
										<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
										&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						  </tbody>
						</Table>
					  </Col>
					  <Col md="5" id="addloan">
					   <form action="" method="post" role="form" id="salform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="3">
								<Label htmlFor="name">Payhead <span className="text-danger">*</span></Label>
							  </Col>
							  <Col md="9">
								<FormGroup>
								  <select name="payhead" onChange={this.onChange} className="form-control" required>
									<option value="">Select Payhead</option>
									{
										pay.map(function (item) {
											return <option value={item.id }>{item.payheadname}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<Label htmlFor="name">Date <span className="text-danger">*</span></Label>
							  </Col>
							  <Col md="9">
								<FormGroup>
								  <DatePicker selected={this.state.tdate} onChange={this.handleDateChange} className="form-control" dateFormat="DD-MM-YYYY"  maxDate={moment()}/>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<Label htmlFor="name">Amount <span className="text-danger">*</span></Label>
							  </Col>
							  <Col md="9">
								<FormGroup>
								  <Input type="text" name="amt" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<Label htmlFor="name">No of dues <span className="text-danger">*</span></Label>
							  </Col>
							  <Col md="9">
								<FormGroup>
								  <Input type="text" name="dues" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
						  </form>
					  </Col>
					  <Col md="5" id="editloan">
					   <form action="" method="post" role="form" id="salupform" encType="multipart/form-data" onSubmit={this.onUpdateSubmit} >
						<CardHeader>
							<strong>Update</strong>
							<Button outline color="primary" className="btn-right" onClick={this.onBack}>Add</Button>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="3">
								<Label htmlFor="name">Payhead <span className="text-danger">*</span></Label>
							  </Col>
							  <Col md="9">
								<FormGroup>
								  <select name="uppayhead" onChange={this.onChange} className="form-control" required value={this.state.uppayhead}>
									<option value="">Select Payhead</option>
									{
										pay.map(function (item) {
											return <option value={item.id }>{item.payheadname}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<Label htmlFor="name">Date <span className="text-danger">*</span></Label>
							  </Col>
							  <Col md="9">
								<FormGroup>
								 <Input type="date" name="update" onChange={this.onChange}  value={this.state.update} required />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<Label htmlFor="name">Amount <span className="text-danger">*</span></Label>
							  </Col>
							  <Col md="9">
								<FormGroup>
								  <Input type="text" name="upamt" required onChange={this.onChange} value={this.state.upamt} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<Label htmlFor="name">No of dues <span className="text-danger">*</span></Label>
							  </Col>
							  <Col md="9">
								<FormGroup>
								  <Input type="text" name="updues" required onChange={this.onChange} value={this.state.updues} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
						  </form>
					  </Col>
					 </Row>
					</CardBody>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default Loan;


// WEBPACK FOOTER //
// ./src/payroll/Loan/Loan.js